/**
 * Satellite filter options. Landsat 8 and 9 are one instrument family to the
 * user, so they're grouped into a single control; the underlying plumes keep
 * their exact `landsat-8` / `landsat-9` keys (from `normalizeSensor`).
 *
 * ASSUMPTION: these are the instruments the real `sensor` column normalizes to.
 * If real data uses other sensors, add options here and extend `normalizeSensor`
 * in api.ts. (A future improvement: build this list dynamically from
 * `meta.sensors` so it always matches the data.)
 */
import type { Satellite } from "./types";

export interface SatelliteOption {
  key: string;
  label: string;
  /** The concrete satellites this option covers. */
  sats: Satellite[];
}

export const SATELLITE_OPTIONS: SatelliteOption[] = [
  { key: "sentinel-2", label: "Sentinel-2", sats: ["sentinel-2"] },
  { key: "landsat", label: "Landsat", sats: ["landsat-8", "landsat-9"] },
  { key: "emit", label: "EMIT", sats: ["emit"] },
];
